export default {
  TYPE: {
    CREATED: { LABEL: 'Linha da Viagem', KEY: 'fullLine', VALUE: 'viagem' },
    PAID: { LABEL: 'Linha da Passagem', KEY: 'ticketLine', VALUE: 'passagem' },
  },
};
